<template>
  <!-- This is not particularly beautiful, but it makes working inside the central component much easier. -->
  <div id="wrapper" class="edith-bg-light"
       :style="{'grid-template-rows': `[top-border] var(--header-height) [header-to-center] ${centralHeight} [center-to-footer] var(--footer-height) [bottom-border]`}">
    <!-- Actual UI -->
    <Header id="header" @logout="() => $emit('logout')"
            :patientData="patientData"></Header>
    <Central id="central" @logout="(error) => $emit('logout', error)"></Central>
    <Footer id="footer"></Footer>

    <!-- Globally managed modals -->
    <LoadingModal :show="showLoadingModal" @modalConfirmed="$emit('logout', null);"></LoadingModal>
    <NoDiagnoseFoundModal :show="showNoDiagnoseFoundModal"
                          @noDiagnoseFoundModalConfirm="() =>{
                            this.$router.push('anfaelle')
                             $store.commit('cdss/setShowNoDiagnoseFoundModal', false)
                          }"></NoDiagnoseFoundModal>
    <DisclaimerForMinorPatient :show="minorPatientShow"
                               @patientIsMinor="()=>{
                                 backToPatientList() ;
                                 this.minorPatientShow = false}"/>
    <PatientInfoConfirm :show="patientInfoConfirmShow && !minorPatientShow"
                        :patient-data="patientData"
                        @toPatientList="()=>{
                                 backToPatientList() ;
                                 this.patientInfoConfirmShow = false}"
                        @patientInfoConfirmed="()=> this.patientInfoConfirmShow = false"/>

  </div>
</template>

<script>

import Header from "./components/header/Header";
import Central from "./components/central/Central";
import Footer from "./components/footer/Footer"
import {mapGetters} from "vuex";
import LoadingModal from "./components/modal/LoadingModal";
import DisclaimerForMinorPatient from "./components/modal/DisclaimerForMinorPatient";

import cdssDocumentObserver, {unsubscribe} from "./js/ui-controlling/cdssDocumentObserver";
import NoDiagnoseFoundModal from "./components/modal/NoDiagnoseFoundModal";
import PatientInfoConfirm from "./components/modal/PatientInforConfirmModal";
import {isAuthenticated} from "../../root/src/js/util";


export default {
  name: 'App',
  components: {
    PatientInfoConfirm,
    DisclaimerForMinorPatient,
    NoDiagnoseFoundModal,
    Header,
    Central,
    LoadingModal,
    Footer
  },
  emits: {
    logout: null,
    loggedOutDueToInactivity: null
  },
  props: {
    patientData: Object
  },
  data() {
    return {
      centralHeight: 0,
      unsubscribeCdssDocumentObserver: undefined,
      minorPatientShow: false,
      patientInfoConfirmShow: true,

    }
  },
  computed: {
    ...mapGetters('cdss', [
      'showLoadingModal',
      'showErrorModal',
      'showUnauthorizedModal',
      'showDisclaimerModal',
      'showNoDiagnoseFoundModal'
    ])
  },
  methods: {
    setCentralSize() {
      this.centralHeight = (window.innerHeight - 170) + 'px'
    },
    backToPatientList() {
      this.$store.reset() //the store is reset in all the levels and modules
      //make sure we still have the ExpirationTime and TokenValidityDuration

      this.$router.replace('/app/secure')

    }
  },
  created() {
    cdssDocumentObserver(this.$store)
    window.addEventListener('resize', this.setCentralSize)
    this.setCentralSize()
    if (this.patientData) {
      this.$store.commit("cdss/setPatient", this.patientData)
      this.$store.dispatch('cdss/loadPatientData', this.patientData)

      let timeDiff = new Date().getTime() - new Date(this.patientData.birthDate).getTime();
      let ageAtFirstAnfall = timeDiff / (1000 * 3600 * 24 * 365);
      if (ageAtFirstAnfall < 18) {
        this.minorPatientShow = true
        this.patientInfoConfirmShow = false
      }
    }

  },
  beforeMount() {
    // The user gets a dialog if he really wants to refresh if he attempts to reload / close if he attempts to close
    window.onbeforeunload = () => false
    // This is not a normal website where this should be allowed. If someone unloads the page for any reason, log her out!
    window.onunload = () => this.$emit('logout')
    if (!isAuthenticated()) {
      this.$emit('logout')
    }

  },
  unmounted() {
    window.removeEventListener('resize', this.setCentralSize);
  },
  destroyed() {
    window.removeEventListener('resize', this.setCentralSize);
    this.$store.commit('cdss/setShowSavedDataFlag', true)
    unsubscribe()
  }
}
</script>

<style>
@import "css/constants.css";


#wrapper {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-areas: "header" "central" "footer";
}

#header {
  grid-area: header;
  overflow: hidden;
}

#central {
  grid-area: central;
  overflow: hidden;
}

#footer {
  grid-area: footer;
  overflow: hidden;
}
</style>
